import { gql } from '../../../../types/__codegen__/sanity';

export const GET_PLACEHOLDERS_QUERY = gql(`
  query AllPlaceholder {
    allPlaceholder {
      _id
      name
      identifier {
        current
      }
    }
  }
`);
